"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.accountsPlan")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.accountsPlan", {
        url: "/plano-de-contas/:source/:year",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-accounts-plan" */ "./accounts-plan.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.accountsPlan")
            );
        },
        views: {
            "admin@nucont.accounting": {
                component: "accountsPlanComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        params: {
            source: { value: null, dynamic: true },
            year: { value: null, dynamic: true },
            openParameterize: { value: null },
            from: { value: null }
        },
        bodyClass: "accounts-plan-module"
    });
}
